import { render } from "./OrdersLogs.vue?vue&type=template&id=7d197ed4"
import script from "./OrdersLogs.vue?vue&type=script&lang=js"
export * from "./OrdersLogs.vue?vue&type=script&lang=js"

import "./OrdersLogs.vue?vue&type=style&index=0&id=7d197ed4&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/logs/OrdersLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d197ed4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d197ed4', __exports__)) {
    console.log('reload')
    api.reload('7d197ed4', __exports__)
  }
  
  module.hot.accept("./OrdersLogs.vue?vue&type=template&id=7d197ed4", () => {
    console.log('re-render')
    api.rerender('7d197ed4', render)
  })

}


export default __exports__